import * as Sentry from '@sentry/react';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { registrarCapturaGlobalDeErros } from '@/api/reportar-erro';
import { Router } from '@/app/router';
import '@/index.css';

const dsn = import.meta.env.VITE_SENTRY_DSN;
if (dsn) {
  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    release: import.meta.env.VITE_APP_VERSION,
    tracesSampleRate: import.meta.env.PROD ? 0.1 : 1.0,
  });
}

// Erro de script e promessa sem `catch` → Administração → Alertas.
registrarCapturaGlobalDeErros();

const raiz = document.getElementById('root');
if (!raiz) throw new Error('Elemento #root não encontrado em index.html');

createRoot(raiz).render(
  <StrictMode>
    <Router />
  </StrictMode>,
);
